export default __webpack_public_path__ + "static/media/energia-y-personas.33562b5d.jpg";